import { redactAuthTokens } from './authTokens';

const FILTERED = '[Filtered]';
const AUTH_KEY = /authorization/i;

/** Recursively scrubs auth-key values (`[Filtered]`) and redacts tokens embedded in string values, in place. */
export function scrubSensitiveKeys(obj: unknown): void {
  scrub(obj, new WeakSet<object>());
}

/** `Object.entries`, a spread `Map` and a header list all carry a key beside its value, where no object key exists to match on. */
function isAuthPair(value: readonly unknown[]): boolean {
  return value.length === 2 && typeof value[0] === 'string' && AUTH_KEY.test(value[0]);
}

function scrub(obj: unknown, seen: WeakSet<object>): void {
  if (!obj || typeof obj !== 'object') return;
  if (seen.has(obj)) return;
  seen.add(obj);

  if (Array.isArray(obj)) {
    if (isAuthPair(obj)) {
      obj[1] = FILTERED;
      return;
    }

    for (let i = 0; i < obj.length; i += 1) {
      const value: unknown = obj[i];
      if (typeof value === 'string') {
        obj[i] = redactAuthTokens(value);
      } else {
        scrub(value, seen);
      }
    }
    return;
  }

  const record = obj as Record<string, unknown>;
  for (const key of Object.keys(record)) {
    if (AUTH_KEY.test(key)) {
      record[key] = FILTERED;
      continue;
    }
    const value = record[key];
    if (typeof value === 'string') {
      record[key] = redactAuthTokens(value);
    } else {
      scrub(value, seen);
    }
  }
}
